export enum POA {
  Y = 'Yes',
  N = 'No',
  U = 'Unknown',
  W = 'Clinically undetermined',
  I = 'Unreported/Not Used (Exempt from POA reporting)',
}

// TODO - implement.
//  Should this be moved to the converter to keep this a true contract?
export const fromPOAValue  = (value: string) => {
  let result = POA.U
  switch (value) {
    case 'Y':
      result = POA.Y;
      break;
    case 'N':
      result = POA.N;
      break;
  }

  return result;
}
